import { render, staticRenderFns } from "./text-side.vue?vue&type=template&id=54e7e680&scoped=true&"
import script from "./text-side.vue?vue&type=script&lang=ts&"
export * from "./text-side.vue?vue&type=script&lang=ts&"
import style0 from "./text-side.vue?vue&type=style&index=0&id=54e7e680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7e680",
  null
  
)

export default component.exports